<template>
    <div :class="$style.page_toggles">
        <Button
            color="carbon-400"
            size="l"
            icon="chevron_l"
            :interfaceTarget="`click-page-${prevPage}`"
            v-bind="props.currentPage <= 1 ? { disabled: true } : { to: getPageLink(prevPage) }"
        />

        <Button
            v-for="page in visiblePages"
            :key="page"
            size="l"
            :to="getPageLink(page)"
            :interfaceTarget="`click-page-${page}`"
            :color="props.currentPage === page ? 'purple-400' : 'carbon-400'"
        >
            {{ page }}
        </Button>
        <Button
            color="carbon-400"
            size="l"
            :interfaceTarget="`click-page-${nextPage}`"
            v-bind="props.currentPage >= props.totalPages ? { disabled: true } : { to: getPageLink(nextPage) }"
            icon="chevron_r"
        />
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { RouteLocationRaw } from 'vue-router'

import Button from '@/components_new/Button.vue'
import { useDeviceSize } from '@/composables/use-device-size'

const props = withDefaults(
    defineProps<{
        totalPages?: number
        currentPage?: number
        numShow?: number
        mobileNumShow?: number
        step?: number
        getPageLink: (page: number) => RouteLocationRaw
    }>(),
    {
        totalPages: 5,
        currentPage: 1,
        numShow: 5,
        mobileNumShow: 3,
        step: 1,
    },
)

const prevPage = computed<number>(() => props.currentPage - 1)
const nextPage = computed<number>(() => props.currentPage + 1)
const { isTabletPlus } = useDeviceSize()

const visiblePages = computed<number[]>(() => {
    const { currentPage, totalPages, numShow, step, mobileNumShow } = props
    const visibleNumShow = isTabletPlus.value ? numShow : mobileNumShow
    const windowIndex = Math.floor((currentPage - step) / 1)
    let start = windowIndex * step + 1
    let end = start + visibleNumShow - 1

    if (end > totalPages) {
        end = totalPages
        start = Math.max(1, end - visibleNumShow + 1)
    }

    const pages: number[] = []
    for (let i = start; i <= end; i++) {
        pages.push(i)
    }

    return pages
})
</script>
<style module>
.page_toggles {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 24px 0;
}
</style>
